import { useV2GetProductQuery, V2EmbeddedProjectVariable } from "@generated";
import { Product } from "../types";

const useGetProduct = (productId: number) => {
  const { data, error, isLoading, isFetching, refetch } = useV2GetProductQuery({
    id: String(productId),
  });

  let product: Product | undefined = undefined;
  let customError: string | null = null;

  if (data?.data && data.data.id) {
    try {
      product = {
        id: Number(data.data.id),
        type: data.data.type,
        attributes: {
          name: data.data.attributes?.name || "",
          description: data.data.attributes?.description || "",
          sku: data.data.attributes?.sku || "",
          intProdID: data.data.attributes?.["product-id"] || "",
          mfgPartNum: data.data.attributes?.["manufacturer-part-number"] || "",
          units: data.data.attributes?.["unit-of-measure"] || "",
          category: data.data.attributes?.category || "",
          subcategory: data.data.attributes?.subcategory || "",
          unitPrice: data.data.attributes?.["unit-price"] || 0,
          unitCost: data.data.attributes?.["unit-cost"] || 0,
          listPrice: data.data.attributes?.["list-price"] || 0,
          variables:
            data.data.attributes?.["project-variables"]?.map((variable) => ({
              ...variable,
              id: variable.uuid ?? "",
              name: variable.name ?? "",
              label: variable.label ?? "",
              value: variable.value ?? "",
              required: variable.required ?? false,
              "variable-type":
                variable["variable-type"] ?? variable.variable_type ?? "text",
              "select-options":
                variable["select-options"] ?? variable.select_options ?? [],
              select_options: variable.select_options ?? [],
              minimum: variable.minimum ?? 0,
              maximum: variable.maximum ?? 0,
              position: variable.position ?? 0,
              context: variable.context ?? "product",
            })) ?? [],
        },
      };
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return {
    product,
    error: error || customError,
    isLoading,
    isFetching,
    refetch,
  };
};

export default useGetProduct;
